<script setup lang="ts">
  import { computed } from 'vue';

  import { Button } from '@ui/components/button';
  import {
    Pagination,
    PaginationContent,
    PaginationEllipsis,
    PaginationFirst,
    PaginationItem,
    PaginationLast,
    PaginationNext,
    PaginationPrevious,
  } from '@ui/components/pagination';

  interface PaginationProps {
    limit: number;
    page: number;
    showEdges?: boolean;
    siblingCount?: number;
    total: number;
  }

  const props = withDefaults(defineProps<PaginationProps>(), {
    showEdges: true,
    siblingCount: 0,
  });
  const emit = defineEmits(['update:page']);

  // Pagination component is 1-based indexed, but we use 0-based index for backend
  const displayPage = computed(() => props.page + 1);
</script>

<template>
  <Pagination
    :total="props.total"
    :sibling-count="siblingCount"
    :page="displayPage"
    :items-per-page="props.limit"
    :show-edges="showEdges"
    @update:page="emit('update:page', $event - 1)"
  >
    <PaginationContent v-slot="{ items }" class="flex items-center gap-1">
      <PaginationFirst />
      <PaginationPrevious />

      <template v-for="(item, index) in items">
        <PaginationItem v-if="item.type === 'page'" :key="index" :value="item.value" as-child>
          <Button variant="ghost">
            {{ item.value }}
          </Button>
        </PaginationItem>
        <PaginationEllipsis v-else :key="item.type" :index="index" />
      </template>

      <PaginationNext />
      <PaginationLast />
    </PaginationContent>
  </Pagination>
</template>

<style scoped></style>
